
import { Form, FormikProvider, useFormik } from "formik";
import React from "react";
import { useState } from "react";
import * as jnb from "react-bootstrap";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";

export default function AloDrillDown() {
  const formIk = useFormik({
    initialValues: {
      district: "",
    },
  });
  const [DashboardData, setDashboardData] = useState([]);
  function GetAloDashboardData() {
    const url = `${config.url.BOC_URL}alotottaldashboard`;
    CommonAxiosGet(url).then((res) => {
      if (res.data?.status === true) {
        setDashboardData(res.data?.alodashboard);
      }
    });
  }
  useEffect(() => {
    GetAloDashboardData();
  }, []);
  let navigate = useNavigate();
  
  function NavigateMapppedMandals(lgd_dist_code,distname) {
    localStorage.setItem("lgd_dist_code",lgd_dist_code);
    localStorage.setItem("distname",distname);
    navigate("/MandalsMapped");
  }
  function PendingMandals(lgd_dist_code, distname) {
    localStorage.setItem("lgd_dist_code",lgd_dist_code);
    localStorage.setItem("distname",distname);
    navigate("/AloDetailsUpdate");
  }
  function alertMessage() {
    Swal.fire({
      text: "No Data Found",
      icon: "info",
      //  showCancelButton: true,
      confirmButtonColor: "#3085d6",
      // cancelButtonColor: "#d33",
      confirmButtonText: "OK",
    }).then((willDelete) => {
      if (willDelete.isConfirmed) {
      }
    });
  }
  return (
    <>
      <div>
        <Header />
        <div className="main_section"> </div>
        <FormikProvider value={formIk}>
          <Form onSubmit={formIk.handleSubmit} onChange={formIk.handleChange}>
            <jnb.Container>
              <jnb.Row>
                <jnb.Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="page-titlespacing d-flex justify-content-between"
                >
                  <div className="inner-herbpage-service-title1">
                    <h1> ALO District wise Dashboard </h1>
                  </div>
                </jnb.Col>
              </jnb.Row>
            </jnb.Container>
            <jnb.Container className="outer-page-content-container">
              <jnb.Row className="px-4 pt-5">
                <Table
                  className="table table-bordered table-striped table-responsive"
                  style={{ textAlign: "nowrap" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>District</th>
                      <th>Total Mandals</th>
                      <th>Mandals Mapped</th>
                      <th>Pending For Mapping</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DashboardData &&
                      DashboardData?.map((item, i) => {
                        return (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.distname}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.mandals}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              <a href="#"
                                onClick={(e) => {
                                  item.mapped_mandals !== 0
                                    ? NavigateMapppedMandals(item.lgd_dist_code, item.distname) : alertMessage();
                                }}
                              >
                                {item.mapped_mandals}
                              </a>

                              {/* <a href="#" onClick={(e)=>NavigateMapppedMandals(item.lgd_dist_code,item.distname)}>{item.mapped_mandals}</a> */}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {/* <a href="#" onClick={(e)=>{PendingMandals(item.lgd_dist_code,item.distname)}>{item.pending_mandals}</a> */}
                              <a
                                href="#"
                                onClick={(e) => {
                                  item.pending_mandals !== 0
                                    ? PendingMandals(
                                      item.lgd_dist_code,
                                      item.distname
                                    )
                                    : alertMessage();
                                }}
                              >
                                {item.pending_mandals}
                              </a>
                            </td>
                            {/* <td style={{ textAlign: "center" }}>
                              <jnb.Button
                                type="submit"
                                className="btn btn-success"
                                style={{ whiteSpace: "nowrap" }}
                                onClick={() => {
                                    // aloupdatenavigate(item.lgd_dist_code)
                                  navigate("/AloDetailsUpdate",{state:{org:item.lgd_dist_code}})
                                 
                                }}>Click Here
                              </jnb.Button>
                            </td> */}
                          </tr>
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center" }}>
                        Total{" "}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce((a, v) => (a = a + v.mandals), 0)}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.mapped_mandals),
                          0
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {DashboardData.reduce(
                          (a, v) => (a = a + v.pending_mandals),
                          0
                        )}
                      </td>
                    </tr>
                  </tfoot>
                </Table>
              </jnb.Row>
            </jnb.Container>
          </Form>
        </FormikProvider>
      </div>
    </>
  );
}
